<script lang="ts">
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import ProductsLastOrderedStore from "@retailer/svelte/stores/ProductsLastOrderedStore";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { Distributor } from "@shared/types/Distributor";

  export let product;
  export let distributor: Distributor;

  const createProductList = () => {
    if (!lastOrdered) return "";

    let list = [];

    if (lastOrdered.case_quantity > 0) {
      list.push(`${pluralize("case", lastOrdered.case_quantity, true)}`);
    }

    if (lastOrdered.unit_quantity > 0) {
      list.push(`${pluralize(lastOrdered.container_type, lastOrdered.unit_quantity, true)}`);
    }

    return list.join(", ");
  };

  let lastOrdered;

  $: {
    const distributorId = distributor?.id;

    if (distributorId) {
      lastOrdered = $ProductsLastOrderedStore.getProductsLastOrderedForDistributorAndProduct(
        distributorId,
        product.id
      );
    }
  }

</script>

{#if lastOrdered}
  <div class="fizz-surface-white">
    <p
      class="fizz-flex-row fizz-align-content-start fizz-stack-16 fizz-text-small fizz-text-subdued"
    >
      <span class="margin-right--none">
        <Icon
          fill="#595959"
          width={16}
          height={16}
          type="History"
          extraClassNames="fizz-inline-4"
        />
      </span>

      <span class="fizz-text-strong"
        >Last ordered on {lastOrdered.submitted_at}:
        <span class="fizz-text-regular">
          {createProductList()}
        </span>
      </span>
    </p>
  </div>
{/if}
